import { InjectionToken } from '@angular/core';
import { environment } from '../../../../environments/environment';

/**
 * The browser APIs the unread-count stream depends on, behind one token so the service's spec
 * replaces network, clock, randomness and session storage by injection — never by swapping a
 * `window` global. Each default wraps the API in an arrow function: calling `window.fetch`
 * detached from `window` throws "Illegal invocation".
 */
export interface MessagesStreamPlatform {
  fetch(url: string, init: RequestInit): Promise<Response>;
  /** Runs `callback` after `delayMs`; the returned function cancels it. */
  schedule(callback: () => void, delayMs: number): () => void;
  /** Uniform in [0, 1). */
  random(): number;
  /** The tab's session id as stored, or `null` when there is none. */
  readSessionId(): string | null;
}

export const MESSAGES_STREAM_PLATFORM = new InjectionToken<MessagesStreamPlatform>('MESSAGES_STREAM_PLATFORM', {
  providedIn: 'root',
  factory: (): MessagesStreamPlatform => ({
    fetch: (url, init) => fetch(url, init),
    schedule: (callback, delayMs) => {
      const handle = setTimeout(callback, delayMs);
      return () => clearTimeout(handle);
    },
    random: () => Math.random(),
    readSessionId: () => sessionStorage.getItem(environment.auth.sessionIdStorageKey),
  }),
});
